import { ca } from '@cian/analytics';

export const trackPlayClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: 'PlayVideo',
  });
};
